export var CLIENT_RATING_SUMMARY_DATA = "CLIENT_RATING_SUMMARY_DATA";
export var CLIENT_RATING_SUMMARY_LOADER = "CLIENT_RATING_SUMMARY_LOADER";
export var CLIENT_RATING_SUMMARY_STOP_LOADER = "CLIENT_RATING_SUMMARY_STOP_LOADER";
